import { useEffect, useState } from 'react';
import { Toggle } from '@veneer/core';
import {
  IPrintPlan,
  ModalInkPlansAnalyticsEvent,
  ModalInkPlansAnalyticsPayload,
} from '../types';
import {
  Header,
  ModelName,
  PlanCards,
  ToggleContainer,
  ToggleLabel,
  WrapperContainer,
} from './styles';
import { PlanCard } from './PlanCard/PlanCard';

interface PrintPlanCardsProps {
  selectedPlan: IPrintPlan;
  paperToggleLabel: string;
  paperAddOnLabel: string;
  showPaper?: boolean;
  onAnalytics?: (data: ModalInkPlansAnalyticsPayload) => void;
}

export const PrintPlanCards = ({
  selectedPlan,
  paperToggleLabel,
  paperAddOnLabel,
  showPaper,
  onAnalytics,
}: PrintPlanCardsProps) => {
  const [showPaperState, setShowPaperState] = useState(showPaper || false);

  useEffect(() => setShowPaperState(showPaper || false), [showPaper]);

  const handleToggle = () => {
    const newState = !showPaperState;
    setShowPaperState(newState);

    if (onAnalytics) {
      onAnalytics({
        eventName: ModalInkPlansAnalyticsEvent.PAPER_TOGGLE,
        payload: {
          enabled: newState,
          modelName: selectedPlan.modelName,
        },
      });
    }
  };

  return (
    <WrapperContainer>
      <Header>
        <ModelName>{selectedPlan.modelName}</ModelName>
        <ToggleContainer>
          <ToggleLabel>{paperToggleLabel}</ToggleLabel>
          <Toggle id="addPaper" on={showPaperState} onChange={handleToggle} />
        </ToggleContainer>
      </Header>
      <PlanCards>
        {selectedPlan.planInfos.map((plan) => (
          <PlanCard
            id={plan.name}
            key={plan.name}
            planInfo={plan}
            showPaper={showPaperState}
            paperAddOnLabel={paperAddOnLabel}
          />
        ))}
      </PlanCards>
    </WrapperContainer>
  );
};
